module.exports = __webpack_public_path__ + "static/img/gywm1.bbfefd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gywm1.png
// module id = f87y
// module chunks = 3